namespace distill {
    // interfaces
    export import IPropertyUpdatedPayload = appn.designerv2.IPropertyUpdatedPayload;
    export import IComponent = appn.designerv2.IComponent;
    export import IComponentDefinition = appn.designerv2.IComponentDefinition;
    export import IPropertyDefinition = appn.designerv2.IPropertyDefinition;
    export import IGridPosition = appn.designerv2.IGridPosition;
    export import ITranslationText = appn.designerv2.ITranslationText;
    export import IFontStyle = appn.designerv2.IFontStyle;
    export import IDesign = appn.designerv2.IDesign;
    export import IPathGuard = appn.designerv2.IPathGuard;

    // designer singletons
    export import designer = appn.designerv2.designer;
    export import eventBus = appn.designerv2.eventBus;
    export import dataCache = appn.designerv2.dataCache;
    export import componentManager = appn.designerv2.componentManager;
    export import editors = appn.designerv2.editors;
    export import canvas = appn.designerv2.canvas;

    // general base singletons
    export import elementBuilder = appn.elementBuilder;
    export import trash = appn.trash;
    export import toast = appn.toast;
    
    // constants
    export import EVENTS = appn.designerv2.EVENTS;

    // classes
    export import EditorBase = appn.designerv2.editors.EditorBase;

    // utils
    export import emptyString = appn.emptyString;
    export import SelectListItem = appn.SelectListItem; 
}
